// src/utils/groupClosingError.js
// A refusal because the group is closing (Roadmap #103). The database raises the stable token
// 'group_closing' (SQLSTATE P0001) for a new article, event or comment in a closing group, and
// for a new member (migration 20261016_group_being_closed.sql). supabaseFetch passes the server's
// JSON error body as error.message, so both the bare token and the JSON form are recognised.
// The text shown is translated (groups:closing_no_new_posts) — never the token itself.

export const GROUP_CLOSING_MESSAGE_KEY = 'groups:closing_no_new_posts';

export function isGroupClosingError(error) {
  if (!error) return false;
  const text = typeof error === 'string' ? error : (typeof error.message === 'string' ? error.message : '');
  if (text === 'group_closing') return true;
  try {
    return JSON.parse(text)?.message === 'group_closing';
  } catch (e) {
    return false;
  }
}
